import { graphql } from "react-relay";

export const RemoveAnthropicIntegrationMutation = graphql`
  mutation RemoveAnthropicIntegrationMutation(
    $input: RemoveAnthropicIntegrationInput!
  ) {
    removeAnthropicIntegration(input: $input) {
      problems {
        message
      }
    }
  }
`;
